import "react-toastify/dist/ReactToastify.css";
import Notification from "@components/ui/Notification";
import React, { ReactNode } from "react";
import { ToastOptions, toast } from "react-toastify";

export const useNotification = () => {
  const withDuration = (
    opts: ToastOptions | undefined,
    delay?: number
  ): ToastOptions => ({
    ...opts,
    // Prefer explicit delay param; fallback to options.autoClose; otherwise default (5000)
    autoClose: delay ?? opts?.autoClose,
  });

  const notification = {
    success: (
      title: string,
      message?: ReactNode,
      options?: ToastOptions<unknown> | undefined
    ) => {
      toast(
        <Notification title={title} variant="success">
          {message}
        </Notification>,
        {
          ...options,
        }
      );
    },
    celebration: (
      title: string,
      message?: ReactNode,
      options?: ToastOptions<unknown> | undefined
    ) => {
      toast(
        <Notification title={title} variant="celebration">
          {message}
        </Notification>,
        {
          ...options,
        }
      );
    },
    warning: (
      title: string,
      message?: ReactNode,
      options?: ToastOptions<unknown> | undefined,
      delay?: number
    ): void => {
      toast(
        <Notification title={title} variant="warning">
          {message}
        </Notification>,
        withDuration(options, delay)
      );
    },
    info: (
      title: string,
      message?: ReactNode,
      options?: ToastOptions<unknown> | undefined
    ) => {
      toast(
        <Notification title={title} variant="info">
          {message}
        </Notification>,
        {
          ...options,
        }
      );
    },
    error: (
      title: string,
      message?: ReactNode,
      options?: ToastOptions<unknown> | undefined
    ) => {
      toast(
        <Notification title={title} variant="error">
          {message}
        </Notification>,
        {
          ...options,
        }
      );
    },
  };
  return notification;
};
